import type { ScreenModule } from "../../../app/screen-module";
import { ArtifactListPage } from "../ArtifactPages";

export default {
	id: "end-user.artifacts",
	path: "/app/artifacts",
	area: "end-user",
	navGroup: "確認する",
	label: "成果物",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "ZEROVIA",
	enabled: true,
	component: ArtifactListPage,
} satisfies ScreenModule;
